/**
 * {@link https://drafts.csswg.org/mediaqueries-5/#mf-scripting}
 *
 * @remarks
 * As noted in Media Queries Level 5, a future level of CSS may extend the
 * scripting feature to allow fine-grained detection of which script is allowed
 * to run. While the `Scripting` class therefore currently seems very sparse, we
 * foresee a need to extend it in the future.
 *
 * @public
 */
export class Scripting {
    static of(enabled) {
        return new Scripting(enabled);
    }
    _enabled;
    constructor(enabled) {
        this._enabled = enabled;
    }
    get enabled() {
        return this._enabled;
    }
    equals(value) {
        return value instanceof Scripting && value._enabled === this._enabled;
    }
    hash(hash) {
        hash.writeBoolean(this._enabled);
    }
    toJSON(options) {
        return {
            enabled: this._enabled,
        };
    }
}
/**
 * @public
 */
(function (Scripting) {
    function isScripting(value) {
        return value instanceof Scripting;
    }
    Scripting.isScripting = isScripting;
    function from(json) {
        return Scripting.of(json.enabled);
    }
    Scripting.from = from;
})(Scripting || (Scripting = {}));
//# sourceMappingURL=scripting.js.map